import { Component, OnInit, OnDestroy, NgZone, ViewChild } from '@angular/core';
import { FormFieldTypes } from '@aws-amplify/ui-components';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AmplifyService } from 'aws-amplify-angular';
import { Auth } from 'aws-amplify';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDrawer } from '@angular/material/sidenav/drawer'
import { User } from './models/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('drawer') private sidenav: MatDrawer;
  private unsubscribe$ = new Subject<void>();
  formFields: FormFieldTypes | undefined;
  title = 'CountyLandData';
  user: User = new User();
  loggedIn: boolean;
  nav = 'login';

  constructor(public amp: AmplifyService, private router: Router, private ds: DataService, private ngZone: NgZone) {
    this.formFields = [
      {
        type: 'email',
        label: 'Email Address  *',
        placeholder: 'Email',
        required: true,
      },
      {
        type: 'password',
        label: 'Password *',
        placeholder: 'Password',
        required: true,
      },
      {
        type: 'phone_number',
        label: 'Phone Number',
        placeholder: '(555) 555-1212',
        required: false,
      }
    ]
  }

  ngOnInit() {
    this.amp.authStateChange$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(authState => {

      switch (authState.state) {
        case 'signedIn':
          this.loggedIn = true;
          this.ds.GetUser()
          .subscribe(n=> this.user = n);
          if (this.sidenav.opened) {
            this.sidenav.toggle();
          }
          this.ngZone.run(() => {
            this.router.navigate(['/home']);
          });
          break;
        
        case 'signedOut':
          this.loggedIn = false;
          this.user = new User();
          this.ds.user = new User();
          this.ds.tabs = [];
          if (this.sidenav.opened) {
            this.sidenav.toggle();
          }
          this.ngZone.run(() => {
            this.router.navigate(['/']);
          });
          break;

        default:
          break;
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onClick(event) {
    this.nav = 'login';

    if (event) {
      this.sidenav.toggle()
    }
  }

  onClickMenu(event) {
    this.nav = 'menu';
    
    if (event) {
      this.sidenav.toggle()
    }
  }

  onClickNav(event) {

    this.router.navigate(['/' + event]);

    if (this.sidenav.opened) {
      this.sidenav.toggle();
    }

  }

  async logOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }
}
